import { defineAsyncComponent } from 'vue';

export default (app: any) => {
	app.component(
		'frontoffice-chat-reservation-full-screen',
		defineAsyncComponent(() => import(/* webpackChunkName: "ChatReservationFullScreen" */ './ChatReservationFullScreen.vue'))
	);
};